import {
  ComponentBox,
  ComponentBoxHeaderFooter,
  enumContainer,
  utils,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import RemoveFilterButton from './RemoveFilterButton';
import styles from './SelectedFilterBox.less';
import SelectedFilters from './SelectedFilters';
import {WallabyCoreSchema} from 'src/js/common/types';
import {FilterSchema} from 'src/js/model/filters_config';

const I18N = defineMessages({
  TITLE: {
    id: 'filter.selectedFilters.title',
    defaultMessage: 'SELECTED FILTERS',
    description: 'title text for selected filters box',
  },
  HELP: {
    id: 'filter.selectedFilters.help',
    defaultMessage:
      'This box is showing the selected filters used in current filtering.',
    description: 'help text for selected filters box',
  },
});

interface OwnProps {
  autocompleteValues: Record<string, any>;
  enumMap: enumContainer.EnumMap;
  hierarchyChildrenLabels?: Record<string, any>;
  organizations?: WallabyCoreSchema.components['schemas']['OrganizationFilterDto'][];
  agens?: WallabyCoreSchema.components['schemas']['PathogenDto'][];
  removeAllFilters: () => void;
  removeFilter: (filter: any) => void;
  selectedFilters?: Record<string, any>[];
  schema: FilterSchema;
}

type Props = OwnProps;

export const SelectedFilterBox: React.FC<Props> = (props) => {
  const {
    agens,
    autocompleteValues,
    enumMap,
    hierarchyChildrenLabels,
    organizations,
    removeAllFilters,
    removeFilter,
    schema,
    selectedFilters,
  } = props;
  const intl = useIntl();

  const showResetButton =
    schema.hasDefaultValueFilters() ||
    (selectedFilters && selectedFilters.length > 0);
  return (
    <div className={styles.dlSelectedFilterBox}>
      <ComponentBoxHeaderFooter
        titleText={utils.TranslateUtils.translate(I18N.TITLE, intl)}
        helpText={utils.TranslateUtils.translate(I18N.HELP, intl)}
      >
        <span
          className={classNames(
            'float-end',
            styles.dlSelectedFilterBoxHeaderContent
          )}
        >
          {showResetButton ? (
            // eslint-disable-next-line react/jsx-indent
            <RemoveFilterButton onClick={removeAllFilters} />
          ) : null}
        </span>
      </ComponentBoxHeaderFooter>
      <ComponentBox hasScrollbar>
        <SelectedFilters
          agens={agens}
          autocompleteValues={autocompleteValues}
          enumMap={enumMap}
          hierarchyChildrenLabels={hierarchyChildrenLabels}
          organizations={organizations}
          removeFilter={removeFilter}
          selectedFilters={selectedFilters}
          schema={schema}
        />
      </ComponentBox>
    </div>
  );
};

SelectedFilterBox.displayName = 'SelectedFilterBox';
